'use client';

import Image from 'next/image';

const logos = [
  { id: 'openai', src: '/images/logo-openai.png', alt: 'OpenAI' },
  { id: 'gemini', src: '/images/logo-gemini.png', alt: 'Gemini' },
  { id: 'claude', src: '/images/logo-claude.png', alt: 'Claude' },
  { id: 'qwen', src: '/images/logo-qwen.png', alt: 'Qwen' },
  { id: 'grok', src: '/images/logo-grok.png', alt: 'Grok' },
  { id: 'aws', src: '/images/logo-aws.png', alt: 'AWS' },
  { id: 'deepseek', src: '/images/logo-deepseek.png', alt: 'Deepseek' },
];

const LatestFeature: React.FC = () => {
  const marqueeLogos = [...logos, ...logos, ...logos, ...logos];

  return (
    <section
      aria-label="Supported AI models"
      className="border-t border-gray-100 bg-white py-8 sm:py-10">
      <p className="text-center text-xs font-medium uppercase tracking-[0.25em] text-gray-400">
        Powered by Every Leading AI Model
      </p>

      <div className="relative mt-6 overflow-hidden sm:mt-8">
        {/* Gradient fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-white to-transparent sm:w-28 md:w-36" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-white to-transparent sm:w-28 md:w-36" />

        {/* Marquee track */}
        <div className="marquee-container">
          <div className="marquee-track">
            {/* Group 1 */}
            <div className="marquee-group">
              {marqueeLogos.map((logo, idx) => (
                <div key={`${logo.id}-${idx}`} className="marquee-item">
                  <Image
                    src={logo.src}
                    alt={logo.alt}
                    width={140}
                    height={40}
                    className="h-5 w-auto object-contain opacity-50 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0 sm:h-6 md:h-7"
                  />
                </div>
              ))}
            </div>

            {/* Group 2 (duplicate for seamless loop) */}
            <div className="marquee-group" aria-hidden="true">
              {marqueeLogos.map((logo, idx) => (
                <div key={`dup-${logo.id}-${idx}`} className="marquee-item">
                  <Image
                    src={logo.src}
                    alt=""
                    width={140}
                    height={40}
                    className="h-5 w-auto object-contain opacity-50 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0 sm:h-6 md:h-7"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestFeature;
